import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
// import { DoctorViewComponent } from './doctor-view.component';

@Injectable({
  providedIn: 'root'
})
export class ClientViewService {

    private subject = new Subject<any>();
    constructor(public router:Router){}

    sendMessage(message: string) {
        this.subject.next(message);
        this.router.navigateByUrl("/clientview");
        message == null;
    }
    clearMessages() {
        this.subject.next();
    }
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}
